import ProductContent from './ProductContent';
import Script from 'next/script';

export default function Detail() {
    return (
        <>
            <Script src="https://www.youtube.com/iframe_api" />
            <ProductContent />
        </>
    );
}
